import React, { Fragment, useEffect, useRef, useState } from "react";
import I18n from "i18n-js";

import { MAX_TASKS } from "../../config/constants";

import ProgressBar from "../../../commons/ProgressBar";
import MultipleActionButton from "../../../commons/MultipleActionButton";

import CopyItemModal from "../Modal/CopyItemModal";
import EditTaskModal from "../Modal/EditTaskModal";

import Shine from "../Shine";
import Task from "./Task";

import plusIcon from "../../../assets/icons/plus.svg"

const ObjectiveInfo = ({ team, plan, objective, selectedTask, showAddTaskButton, onTaskSelect }) => {

  const [selectedObjective, setSelectedObjective] = useState(null);
  const [pickedTask, setPickedTask] = useState(null);

  const [showTaskPicker, setShowTaskPicker] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const objectiveRef = useRef();

  const totalTasksCount = selectedObjective?.tasks?.length;
  const completedTasksCount = selectedObjective?.tasks?.filter(t => t.status === "completed")?.length;
  const progress = Math.round(selectedObjective?.progress * 100.0);

  useEffect(() => {
    objectiveRef.current = objective;
    setSelectedObjective(objective);
  }, [objective]);

  const selectTask = (task) => {
    onTaskSelect && onTaskSelect(task);
  }

  const handleShineAnimationEnd = () => {
    const objective = objectiveRef.current;
    if (objective?.index !== selectedObjective?.index) {
      setSelectedObjective(objective);
    }
  }

  const handleTaskSelect = (task) => {
    setShowTaskPicker(false);
    setPickedTask(task);
    setShowEditModal(true);
  }

  const handleEditModalHide = () => {
    setShowEditModal(false);
    setPickedTask(null);
  }

  return (
    <Fragment>
      <div className="objective-info">
        <Shine trigger={objective} onAnimationEnd={handleShineAnimationEnd} />
        <div className="info right-padding">
          <span className="index">{I18n.t("pdp.objectives.info.index", { index: selectedObjective?.index })}</span>
          <span className="title" title={selectedObjective?.title}>{selectedObjective?.title}</span>
        </div>
        <div className="separator" />
        <div className="tasks-progress right-padding">
          <ProgressBar value={progress} />
          <span className="indicator">
            {I18n.t("pdp.objectives.info.progress.indicator", {
              completed_tasks: completedTasksCount,
              total_tasks: totalTasksCount,
              progress: progress
            })}
          </span>
        </div>
        <div className="separator" />
        <div className="tasks">
          <span className="title">{I18n.t("pdp.objectives.info.tasks")}</span>
          <div className="items">
            {selectedObjective?.tasks?.map((task, index) => (
              <Task
                key={index}
                task={task}
                selected={task.index === selectedTask?.index}
                onSelect={selectTask}
              />
            ))}
          </div>
        </div>
        <div className="actions right-padding">
          {showAddTaskButton ? (
            <MultipleActionButton
              title={I18n.t("pdp.objectives.info.actions.add_task.title")}
              icon={plusIcon}
              actions={[
                {
                  title: I18n.t("pdp.objectives.info.actions.add_task.options.copy_existing"),
                  onClick: () => setShowTaskPicker(true)
                },
                {
                  title: I18n.t("pdp.objectives.info.actions.add_task.options.create_new"),
                  onClick: () => setShowEditModal(true)
                }
              ]}
              disabled={selectedObjective?.tasks?.length >= MAX_TASKS}
            />
          ) : null}
        </div>
      </div>
      <CopyItemModal
        show={showTaskPicker}
        type="task"
        team={team}
        onSelect={handleTaskSelect}
        onCancel={() => setShowTaskPicker(false)}
      />
      <EditTaskModal
        operation="create"
        show={showEditModal}
        plan={plan}
        objective={objective}
        task={pickedTask}
        onSave={handleEditModalHide}
        onCancel={handleEditModalHide}
      />
    </Fragment>
  );
}

export default ObjectiveInfo;
